"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  statisticAnalysis: {
    statisticAnalysis: 'Statistic Analysis',
    comprehensive: 'Comprehensive statistics',
    rentArrears: 'Details of rent arrears',
    ownedShip: 'Chartered/Owned Ships',
    statisticalYear: 'Statistical Year',
    searchType: 'Search Type',
    searchTime: 'Search Time',
    statistical: 'Statistical Time',
    supFlag: 'Supply audit  audit',
    trkFlag: 'Maintenance',
    voyageStartFrom: 'Voyage date',
    statisticalFrom: 'Statistical Time From',
    statisticalFrom0: 'Statistical Time',
    to: 'To',
    fuelStatistics: 'Fuel Statistics',
    addingFuel: 'Adding Fuel Statistics',
    monthlyRobCon: 'Monthly Oil Statistics',
    monthlyLube: 'Monthly Lube Statistics',
    stmcRpt: 'RPM MT NM Consumption',
    fuelDetail: 'Fuel Consumption Statistics',
    fuelSaved: 'Fuel Saved Statistics',
    fuelConsumption: 'Fuel Consumption Statistics(Finished)',
    fuelVoyageType: 'Fuel Consumption(Voyage Type) Statistics',
    fuelVolAmount: 'Fuel VOL.&Amount Statistics',
    topTenTenantsStatistics: 'Top Ten Tenants Statistics',
    topTenBrokerStatistics: 'Top Ten Broker Statistics',
    topTenAgentStatistics: 'Top Ten Agent Statistics',
    rowNo: 'Seq.',
    chartererNameEn: 'Tenant Name',
    qtySum: 'Qty Sum',
    qtyPercent: 'Qty Percent',
    qtySumVc: 'Voyages Num',
    qtyPercentVc: 'Voyages Percent',
    qtyIncome: 'Qty Income',
    qtyIncomePercent: 'Qty Income Percent',
    qtyNum: 'Qty Number',
    qtyNumPercent: 'Qty Number Percent',
    byQty: 'By Qty',
    byNetIncome: 'By Net Income',
    byTotalIncome: 'By Total Revenue',
    byVcVoyageNum: 'By VC Voyage Num',
    byPortCharges: 'By Port Charges',
    byAgencyFeeIncome: 'By Agency Fee Income',
    byCommRevenue: 'By Comm Revenue',
    byFixtureOrder: 'By Fixture Order',
    agentCount: 'Agent Count',
    agentName: 'Agent Name',
    usageAmount: 'Usage Amount',
    proportionTotalAmount: 'Proportion To Total Amount',
    agencyFeeIncome: 'Agency Fee Income',
    proportionTotalFrequency: 'Proportion Of Total Frequency',
    voyageType: 'Voyage Type',
    //账龄查询
    summaryByTenant: 'Summary by Tenant',
    summaryByAging: 'Summarize by aging',
    agingQuery: 'Aging Query',
    queryByTenantGroup: 'Query by Tenant Group',
    tenant: 'Tenant',
    tenantName: 'Tenant Name',
    shipping: 'Shipping',
    voyageNo: 'Voyage No',
    broker1NameEn: 'Broker',
    contractDate: 'Contract Date',
    invoiceNo: 'Invoice No',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    invoiceType: 'Invoice Type',
    amount: 'Amount',
    aging: 'Aging',
    creator: 'Creator',
    approvedBy: 'Approved By',
    agingDate: 'Aging Date',
    agingRange: 'Aging Range',
    chargeType: 'Charge Type',
    operatingCompany: 'Operating company',
    queryByShipGroup: 'Query by ship group',
    //应收未收一览表
    queryReceivableItem: 'List Of Receivable',
    currencyCode: 'Currency',
    invoiceAmount: 'Amount Receivable',
    commAmount: 'Commission',
    day30: 'Within 30 Days',
    day90: '31-90 Days',
    day180: '91-180 Days',
    day365: '181-365 Days',
    day730: '366-730 Days',
    day99999: 'Over 731 Days',
    balanceAmount: 'Balance Amount',
    vesselType: 'Vessel Type',
    invoiceDateFrom: 'Invoice Date From',
    sequence: 'Show Seq',
    //账龄分析查询
    agingAnalysisQuery: 'Aging analysis query',
    analysisType: 'Analysis Type',
    department: 'department',
    voyageEndsFrom: 'Voyage ends from',
    voyageEnd: 'Voyage End',
    area: 'Area',
    abandonedInvoiceNo: 'Abandoned Invoice No',
    invoiceCurrency: 'Invoice Currency',
    paymentDate: 'Payment Date',
    collectionDate: 'Collection date',
    tenantReplyDate: 'Tenant Reply Date',
    ownerCounterDate: 'Owner COUNTER Date',
    latestTrackingContent: 'Latest Tracking Content',
    ownerShip: 'Is Owner',
    routeName: 'Route Name',
    //账龄统计
    agingStatistics: 'Aging Statistics',
    compareWith: 'Compare With',
    displayBefore: 'Display Before',
    percentage: 'Percentage',
    month: 'Month',
    vesselVoyageStatistics: 'Vessel Voyage Statistics',
    //空放燃油统计
    ballastStatistics: 'Ballast Fuel Statistics',
    ballastActualTitle: 'Actual[Distance: NM,Time: D, Cost: MT,Cost Ratio: MT/D]',
    ballastEstimateTitle: 'Estimate[Distance: NM,Time: D, Cost: MT,Cost Ratio: MT/D]',
    ballastDistance: 'Ballast Distance',
    ballastTime: 'Ballast Time',
    voyageSpeed: 'Voyage Speed',
    heavyFuelCost: 'Heavy Fuel Cost',
    heavyFuelCostRatio: 'Heavy Fuel Cost Ratio',
    //每周燃油统计
    weeklyFuelStatistics: 'Weekly Fuel Statistics',
    buyDate: 'Buy Date',
    buyQuantity: 'Buy Quantity',
    buyPrice: 'Buy Price',
    marketPrice: 'Market Price',
    //实际与测算对比
    actualCompare: 'Acutal Compare Estimate',
    ballastFuelConsumption: 'Ballast Fuel Consumption',
    heavyFuelConsumption: 'Heavy Fuel Consumption',
    portFuelConsumption: 'Port Fuel Consumption',
    totalFuelConsumption: 'Total Fuel Consumption',
    actualAvgPrice: 'Actual Avg Price',
    totalFee: 'Total Fee',
    totalFuelFee: 'Total Fuel Fee',
    actualHeavyOil: 'Actual Heavy Oil',
    actualLightOil: 'Actual Light Oil',
    estimateHeavyOil: 'Estimate Heavy Oil',
    estimateLightOil: 'Estimate Light Oil',
    differenceValue: 'Difference Value',
    heavyOil: 'Heavy Oil',
    lightOil: 'Light Oil',
    actualCost: 'Actual Cost',
    estimateCost: 'Estimate Cost',
    ratio: 'Ratio',
    //订单
    orderSatatistics: 'Order Statistics',
    orderDate: 'Order Date',
    orderStatus: 'Order Status',
    orderType: 'Order Type',
    estimateDate: 'Estimate Date',
    newestOrderReceipt: 'Newest Order Receipt',
    newestInvoiceReceipt: 'Newest Invoice Receipt',
    //Tce
    checkData: 'Check data',
    estimated: 'Estimated voyage revenue',
    statisticalIncome: 'Statistical table of operating income',
    detailedIncome: 'Prepare a detailed table of operating income',
    tceRevenue: 'TCE/Revenue',
    revenueByType: 'By VC/TC/TCT',
    revenueByVessels: 'By vessels',
    revenueTceByNow: 'TCE by now',
    tceMgtRptByMonth: 'TCE Mgt Rpt by month',
    tceMgtRptByNow: 'TCE Mgt Rpt by now',
    opertingTceByMonth: 'Operting TCE by month',
    whetherDays: 'Whether to include empty days in operating days',
    vesselTypes: 'Ship Type',
    plannedDays: 'planned voyage included in the operating days ',
    //航次预结算/结算统计报表
    preSettlemenetReport: 'Pre Settlement Report',
    settlementReport: 'Settlement Report',
    vesselCode: 'Vessel Code',
    voyageBeginDate: 'Start Date',
    voyageEndDate: 'End Date',
    calenderDays: 'Calender Days',
    preOperatingDays: 'Pre Operating Days',
    mooringDay: 'Mooring Day',
    pocPer: 'POC Percentager',
    vesselManageCompany: 'Vessel Manage Company',
    operationMode: 'Operation Mode',
    freightVolume: 'Freight Volume(tons)',
    turnOverVolume: 'Turn Over Volume(Thousand tons per nautical mile)',
    reportVersion: 'Report Version',
    voyageFee: 'Voyage Fee',
    freightFee: 'Freight Fee',
    otherFee: 'Other Incidental',
    charteringCost: 'Chartering Cost',
    fuelProcure: 'Fuel Procure Statistics',
    reportStatisticsMonitor: 'Report Statistics Monitor',
    monthVesselVoyageReport: 'Monthly Vessel Voyage Report'
  }
};